import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { Scorecard } from '@/typings/scorecard';
import { computed, onMounted, PropType, ref, toRefs } from 'vue';


export default /*#__PURE__*/_defineComponent({
  props: {
  scorecard: {
    type: Object as PropType<Scorecard>,
    required: true,
  },
},
  setup(__props) {

const props = __props



const { scorecard } = toRefs(props);

const showCountdown = ref(true);

function formatDate(time: string, status: string): string {
  if (['Locked', 'Closed'].includes(status)) {
    return '';
  }
  return new Date(time).toLocaleString();
}

function pad(n: number, width: number, z?: string) {
  const val = z || '0';
  return `${n}`.length >= width
    ? `${n}`
    : `${new Array(width - `${n}`.length + 1).join(val)}${n}`;
}

function remainingTime(): string {
  if (
    timeParts.value[0] >= 0 &&
    timeParts.value[1] >= 0 &&
    timeParts.value[2] >= 0
  ) {
    return `${pad(timeParts.value[0], 2)}:${pad(timeParts.value[1], 2)}:${pad(
      timeParts.value[2],
      2
    )}`;
  }
  switch (scorecard.value.Status) {
    case 'Scheduled':
      return 'Opening soon...';
    case 'Open':
      return 'Locking soon...';
    default:
      return '';
  }
}

const content = computed((): string => {
  if (!showCountdown.value) {
    switch (scorecard.value.Status) {
      case 'Scheduled':
        return `Scheduled ${formatDate(
          scorecard.value.OpensAt,
          scorecard.value.Status
        )}`;
      case 'Open':
        return `Open ${formatDate(
          scorecard.value.LocksAt,
          scorecard.value.Status
        )}`;
      case 'Finalising':
        return 'Results Finalizing';
      default:
        return '';
    }
  }

  switch (scorecard.value.Status) {
    case 'Scheduled':
      return `Opening in ${remainingTime()}`;
    case 'Open':
      return `Locking in ${remainingTime()}`;
    case 'Closed':
    case 'Locked':
      return '';
    case 'Finalising':
      return 'Results Finalizing';
    default:
      return remainingTime();
  }
});

function switchContext() {
  showCountdown.value = !showCountdown.value;
}

const timeParts = ref([0, 0, 0]);
const countdownInterval = ref();
const viewSwitchInterval = ref();

onMounted(() => {
  countdownInterval.value = setInterval(() => {
    const now = new Date().valueOf();
    let distance = 0;
    if (scorecard.value.Status === 'Scheduled') {
      distance = new Date(scorecard.value.OpensAt).valueOf() - now;
    } else {
      distance = new Date(scorecard.value.LocksAt).valueOf() - now;
    }
    const seconds = Math.floor((distance / 1000) % 60);
    const minutes = Math.floor((distance / 1000 / 60) % 60);
    const hours = Math.floor(distance / (1000 * 60 * 60));
    timeParts.value[0] = hours;
    timeParts.value[1] = minutes;
    timeParts.value[2] = seconds;
  }, 1000);

  viewSwitchInterval.value = setInterval(() => {
    showCountdown.value = !showCountdown.value;
  }, 20000);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "px-3 py-1 text-sm text-left text-white cursor-pointer select-none bg-primary",
    onClick: switchContext
  }, _toDisplayString(_unref(content)), 1))
}
}

})